import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 14.7409L8.413 14.7259L18.045 5.18593C18.423 4.80793 18.631 4.30593 18.631 3.77193C18.631 3.23793 18.423 2.73593 18.045 2.35793L16.459 0.77193C15.703 0.0159298 14.384 0.0199297 13.634 0.76893L4 10.3109V14.7409ZM15.045 2.18593L16.634 3.76893L15.037 5.35093L13.451 3.76593L15.045 2.18593ZM6 11.1449L12.03 5.17193L13.616 6.75793L7.587 12.7289L6 12.7339V11.1449Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2 18.7279H16C17.103 18.7279 18 17.8309 18 16.7279V8.05991L16 10.0599V16.7279H5.158C5.132 16.7279 5.105 16.7379 5.079 16.7379C5.046 16.7379 5.013 16.7289 4.979 16.7279H2V2.72791H8.847L10.847 0.727905H2C0.897 0.727905 0 1.62491 0 2.72791V16.7279C0 17.8309 0.897 18.7279 2 18.7279Z",
		fill: "currentColor"
	})]
});
export default SvgEdit;
